/**
 * Version 0.100
 *
 * Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
 * Copyright 2016 - 2025.
 *
 * !Changelog
 *
 * 2018
 * 	17-10-2018
 * 	- [BORN] This class is born. Hooray!
 *
 * !Usage
 *
 * 	-
 *
 * !Wishlist
 *
 * 	none
 */

var specific_interactions_firstload = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function () {

		/**
		 * Trigger: modal and popup preloader
		 */
		images.preload();
		modal.onready();
		popup.onready();
		form.onready();
		if (pollConnection === 1) { poll_connection.onready(); }

		/**
		 * Trigger: onready classes
		 */
		specific_mobilemenu.onready();

		/**
		 * Visitor recording
		 */
		//specific_visitor_recording.onready();

		/**
		 * Trigger: onready specific classes
		 */
		specific_ufo.onready();

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none

}).apply(specific_interactions_firstload); 
